import { BrowserModule }        from '@angular/platform-browser';
import { 
  FormsModule,
  ReactiveFormsModule
}                               from '@angular/forms';
import { 
  HttpModule,
  BrowserXhr 
}                               from '@angular/http';
import {
  NgModule,
  ApplicationRef,
  Injectable
}                               from '@angular/core';
import {
  removeNgStyles,
  createNewHosts,
  createInputTransfer
}                               from '@angularclass/hmr';
import {
  RouterModule,
  PreloadAllModules
}                               from '@angular/router';
import { 
  BrowserAnimationsModule 
}                               from '@angular/platform-browser/animations';

import { ServiceWorkerModule }  from '@angular/service-worker';

/*
 * Platform and Environment providers/directives/pipes
 */
import { ENV_PROVIDERS }        from './environment';
import { ROUTES }               from './app.routes';

import { NgbModule }						from "@ng-bootstrap/ng-bootstrap";

import {
  CtmModule,
  GlobalState,

  AuthGuard,
  RoleGuard,
  ConfirmChangeScreenGuard
}									              from "./_common";
import{
  CtmConstantService
}                               from "./_custom";

// App is our top level component
import { AppComponent }         from './app.component';
import { 
  APP_RESOLVER_PROVIDERS 
}                               from './app.resolver';
import { 
  AppState, 
  InternalStateType 
}                               from './app.service';

import { Error404Component }    from "./screens/errors/404.component";
import { Error503Component }    from "./screens/errors/503.component";

import '../styles/styles.scss';

// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState,
  GlobalState,

  AuthGuard,
  RoleGuard,
  ConfirmChangeScreenGuard
];

@Injectable()
export class CustomBrowserXhr extends BrowserXhr {
  build(): any {
	let xhr = super.build();
    xhr.withCredentials = true;
    return <any>(xhr);
  }
}

type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [ AppComponent ],
  declarations: [
    AppComponent,

    Error404Component,
    Error503Component
  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,

    ServiceWorkerModule.register('ngsw-worker.js', { enabled: true }),
    
    RouterModule.forRoot(ROUTES, {
      //useHash: Boolean(history.pushState) === false,
		  useHash: true,
      preloadingStrategy: PreloadAllModules
    }),

    NgbModule.forRoot(),
    CtmModule.forRoot()
  ],
  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [
    ENV_PROVIDERS,
    APP_PROVIDERS,
    {
      provide: BrowserXhr,
      useClass: CustomBrowserXhr
    },
    CtmConstantService
  ]
})
export class AppModule {
  constructor(
    public appRef: ApplicationRef,
    public appState: AppState
  ) {}

  public hmrOnInit(store: StoreType) {
    if (!store || !store.state) {
      return;
    }
    console.log('HMR store', JSON.stringify(store, null, 2));
    
    /**
     * Set state
     */
    this.appState._state = store.state;
    /**
     * Set input values
     */
    if ('restoreInputValues' in store) {
      let restoreInputValues = store.restoreInputValues;
      setTimeout(restoreInputValues);
    }

    this.appRef.tick();
    delete store.state;
    delete store.restoreInputValues;
  }

  public hmrOnDestroy(store: StoreType) {
    const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
    /**
     * Save state
     */
    const state = this.appState._state;
    store.state = state;
    /**
     * Recreate root elements
     */
    store.disposeOldHosts = createNewHosts(cmpLocation);
    /**
     * Save input values
     */
    store.restoreInputValues  = createInputTransfer();
    /**
     * Remove styles
     */
    removeNgStyles();
  }

  public hmrAfterDestroy(store: StoreType) {
    /**
     * Display new elements
     */
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.module.ts